import { isNonEmptyString } from '@nx/stdlib';

import { selectAuraConfiguration } from '../slices/configuration';
import type { RootState } from '../store-kit';

/**
 * @param api `storageApiUrl` is the old API, `sharedStorageApiUrl` is the new API (defaults to `storageApiUrl`)
 */
export function getSharedStorageUrl(
  state: RootState,
  logger?: (...msg: unknown[]) => void,
  api: 'storageApiUrl' | 'sharedStorageApiUrl' = 'storageApiUrl',
) {
  const auraConfig = selectAuraConfiguration(state);
  const storageUrl = auraConfig?.[api];
  if (!isNonEmptyString(storageUrl)) {
    logger?.(`Storage API URL for ${api} is not defined`);
  }

  return storageUrl;
}
